import React from 'react';
import MedicationLandingPage from '../components/MedicationLandingPage';

const data = {
  slug: 'epipen',
  etsyUrl: 'https://www.etsy.com/shop/MyGuardPod?ref=seller-platform-mcnav&section_id=57791610',
  en: {
    title: 'EpiPod Protective Carrying Case',
    subtitle: 'Purpose-built carrying case format designed to fit the EpiPen\u00ae auto-injector container.',
    aboutTitle: 'About EpiPen\u00ae',
    aboutText: 'EpiPen\u00ae is an epinephrine auto-injector prescribed for emergency treatment of severe allergic reactions. Product information, indications, dosage and administration instructions are established by the medication manufacturer and by the user\u2019s healthcare professional.',
    whyTitle: 'Why a fitted carrying case',
    whyText: 'Auto-injectors are often carried loose in bags, purses or pockets. A fitted carrying case can help keep the container organized, visible and identified during everyday carry.',
    whyPoints: [
      'Format-specific organization',
      'Highly visible identification',
      'Fitted layout for the specific listed medication format',
      'Added physical barrier during everyday carry',
      'Quick-opening carrying-case design',
      'Made to order in Qu\u00e9bec, Canada',
      'Medication and medical supplies not included',
    ],
    howTitle: 'What the EpiPod is',
    howText: 'The EpiPod is a protective carrying case format designed to contain, organize, identify and transport an EpiPen\u00ae auto-injector container. It does not administer, dose, monitor, preserve or modify the medication.',
    ctaTitle: 'Get your EpiPod',
  },
  fr: {
    title: '\u00c9tui protecteur EpiPod',
    subtitle: 'Format d\u2019\u00e9tui de transport con\u00e7u pour accueillir le contenant de l\u2019auto-injecteur EpiPen\u00ae.',
    aboutTitle: '\u00c0 propos d\u2019EpiPen\u00ae',
    aboutText: 'EpiPen\u00ae est un auto-injecteur d\u2019\u00e9pin\u00e9phrine prescrit pour le traitement d\u2019urgence de r\u00e9actions allergiques s\u00e9v\u00e8res. Les renseignements sur le produit, les indications, la posologie et les instructions d\u2019administration sont \u00e9tablis par le fabricant du m\u00e9dicament et par le professionnel de la sant\u00e9 de l\u2019utilisateur.',
    whyTitle: 'Pourquoi un \u00e9tui ajust\u00e9',
    whyText: 'Les auto-injecteurs sont souvent transport\u00e9s libres dans des sacs, sacs \u00e0 main ou poches. Un \u00e9tui ajust\u00e9 peut aider \u00e0 garder le contenant organis\u00e9, visible et identifi\u00e9 pendant le transport quotidien.',
    whyPoints: [
      'Organisation adapt\u00e9e au format',
      'Identification tr\u00e8s visible',
      'Am\u00e9nagement ajust\u00e9 au format de m\u00e9dicament indiqu\u00e9',
      'Barri\u00e8re physique ajout\u00e9e pendant le transport quotidien',
      'Ouverture rapide de l\u2019\u00e9tui',
      'Fabriqu\u00e9 sur commande au Qu\u00e9bec, Canada',
      'M\u00e9dicament et mat\u00e9riel m\u00e9dical non inclus',
    ],
    howTitle: 'Qu\u2019est-ce que l\u2019EpiPod',
    howText: 'L\u2019EpiPod est un format d\u2019\u00e9tui de transport protecteur con\u00e7u pour contenir, organiser, identifier et transporter un contenant d\u2019auto-injecteur EpiPen\u00ae. Il n\u2019administre, ne dose, ne surveille, ne conserve et ne modifie aucun m\u00e9dicament.',
    ctaTitle: 'Obtenez votre EpiPod',
  },
};

const EpipenCasePage = () => <MedicationLandingPage medication={data} />;
export default EpipenCasePage;
